import APIService from './services/APIService';

let user = null;

const getAuthToken = () => {
    return localStorage.getItem('authtoken');
};

const storeAuthToken = (token) => {
    if (!token)
        localStorage.removeItem('authtoken');
    else
        localStorage.setItem('authtoken', token);
};

const getUser = async (force=false) => {
    if (user && !force) {
        return user;
    }

    return APIService.getUser()
        .then((_user) => {
            user = _user;
            return user;
        }).catch((e) => {
            if (user || getAuthToken()) {
                storeAuthToken(null);
                window.location.href = '/';
            }
        });
};

const isAdmin = () => {
    return (user && user.role.level == 10);
};

const isOrganisation = () => {
    return (user && user.role.level == 2);
};

const isUser = () => {
    return (user && user.role.level == 1);
};

const login = async (username, password) => {
    return APIService.doLogin(username, password)
        .then((result) => {
            storeAuthToken(result.access_token);
            return true;
        });
};

const logout = async () => {
    return APIService.doLogout()
        .then(() => {
            this.user = null;
            storeAuthToken(null);
        });
};

const AppContext = {
    APIService,
    getAuthToken,
    storeAuthToken,
    getUser,
    isAdmin,
    isOrganisation,
    isUser,
    login,
    logout
};

export default AppContext;



// WEBPACK FOOTER //
// ./resources/assets/js/AppContext.js